export const languages = [
    { code: 'en', label: 'English' },
    { code: 'ja', label: '日本語' }
];
export var LanguagesEnum;
(function (LanguagesEnum) {
    LanguagesEnum["EN"] = "en";
    LanguagesEnum["JP"] = "ja";
})(LanguagesEnum || (LanguagesEnum = {}));
